import { pricingPageData_en } from "@/shared/data/pricing.data";
import { Typography } from "@graphy/ui";
import HeroPill from "../atoms/HeroPill";
import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";
import PricingCard, { PlansType as BasePlansType } from "./PricingCard";
import PricingHeroHeading from "./PricingHeroHeading";

// Extend PlansType to include ctasBelow for Indian pricing
interface PlansTypeWithCtasBelow extends BasePlansType {
  ctasBelow?: CtaType[];
}

const PricingComparisonNewEn = ({ countryCode = "IN" }: { countryCode?: string }) => {
  const data = pricingPageData_en.planComparisonSectionProps;
  const isIndiaPricing = countryCode === "IN";
  return (
    <div className="w-full flex flex-col items-center gap-8">
      <div className="flex flex-col items-center gap-3">
        {data.heroPill?.category && (
          <HeroPill category={data.heroPill.category} className="bg-white font-bold" textColor="#2A2861"/>
        )}
        <div className="relative pr-4 text-center sm:pr-3">
          <PricingHeroHeading heading={data.title} isComparePlans={true} />
        </div>
        {data.subDescription && (
          <Typography
            fontSize="text-body"
            colorClass="text-grey-3"
            fontWeight="font-normal"
            className="max-w-md mt-1"
            align="text-center"
          >
            {data.subDescription}
          </Typography>
        )}
      </div>
      <div className="flex flex-col md:flex-row justify-center items-center md:items-stretch gap-6 w-full">
        {data.plans.map((plan: PlansTypeWithCtasBelow, idx: number) => {
          const bg = plan.recommened ? "bg-[#F1F0FF]" : "bg-white";
          return (
            <div
              key={plan.planName}
              className={`flex flex-col w-[384px] h-[440px] border border-[#E5E5E5] rounded-[16px] overflow-hidden ${bg} mb-6 md:mb-0`}
            >
              <PricingCard {...plan} billingCycle="year" showBilledAnnually={true} isIndiaPricing={isIndiaPricing} />
              {plan.ctasBelow && plan.ctasBelow.length > 0 && (
                <div className="p-6 pt-0">
                  <CtaButtonGroup ctas={plan.ctasBelow} align="stretch" fullWidth={true} />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="w-full flex justify-center mt-2">
        <span className="text-xs text-grey-3">*iOS app is available as a paid add-on</span>
      </div>
    </div>
  );
};

export default PricingComparisonNewEn;